import { render, staticRenderFns } from "./myTopic.vue?vue&type=template&id=5d079e0e&scoped=true&"
import script from "./myTopic.vue?vue&type=script&lang=js&"
export * from "./myTopic.vue?vue&type=script&lang=js&"
import style0 from "./myTopic.vue?vue&type=style&index=0&id=5d079e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d079e0e",
  null
  
)

export default component.exports